/* eslint-disable import/prefer-default-export */

export const ROUTE_NAMES = {
  analytics: 'analytics',
  analytics_v1: 'analytics-v1',
  appearance: 'appearance',
  bulkEnrollment: 'enrollment',
  bulkEnrollmentResults: 'bulk-enrollment-results',
  codeManagement: 'coupons',
  contentHighlights: 'content-highlights',
  learners: 'learners',
  learners_v2: 'learners-v2',
  learnerCredit: 'learner-credit',
  peopleManagement: 'people-management',
  reporting: 'reporting',
  settings: 'settings',
  subscriptionManagement: 'subscriptions',
};

export const BUDGET_STATUSES = {
  active: 'Active',
  expired: 'Expired',
  expiring: 'Expiring',
  scheduled: 'Scheduled',
  retired: 'Retired',
};

export const BUDGET_TYPES = {
  ecommerce: 'ecommerce',
  subsidy: 'subsidy',
  policy: 'policy',
};
